<pep-message-dialog [title]="'Service Modus aktivieren'"
              [showCancelButton]="true"
              [acceptButtonText]="'Ok'"
              (pushAccept)="save()"
              (pushCancel)="closeDialog()"
              (pushClose)="closeDialog()">
    <div style="padding-bottom: 10px;">
        Sind Sie sich sicher, dass Sie das Terminal in den Service Modus schalten wollen?<br />
        Wenn Sie mit "Ok" bestätigen, wird das Terminal kurze Zeit später als Offline angezeigt.
    </div>
</pep-message-dialog>
